/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useCurrentUser from "../services/useCurrentUser";
import { getAccessToken } from "../storage/storage";
import globalAxios from "../services/globalAxios";
import { PageLoader } from "../components/shared/PageLoader";
import ScrollToTop from "./ScrollToTop";
import WalletCardPreview from "../pages/WalletCardpreview";
import HistoryPage from "../pages/history";

// Auth pages
import Login from "../pages/auth/login/Signin";
import Signup from "../pages/auth/signup/Signup";
import ForgotPassword from "../pages/auth/forgot-password/ForgotPassword";
import ResetPassword from "../pages/auth/reset-password/ResetPassword";

// Other pages
import Home from "../pages/home/Home";
import ContactForm from "../pages/contact/Contact";
import Landing from "../pages/landing/Landing";
import MedicalSummary from "../pages/summary/MedicalSummary";
import VerifyPage from "../pages/auth/otp";
import Membership from "../pages/membership";
import CheckoutPage from "../pages/membership/checkout";
import ReferralPage from "../pages/referral";
import Profile from "../pages/Profile";
import MedicalLicenseForm from "../pages/medicallicenseform";
import About from "../pages/about";
import EditProfile from "../components/EditProfile";

const Routing = () => {
  const token = getAccessToken();

  const { loading, getCurrentUser } = useCurrentUser();

  useEffect(() => {
    if (token) {
      getCurrentUser(token);
    }
  }, [token]);

  return (
    <>
      {loading && <PageLoader />}
      <Router>
        <Routes>
          <Route path="/history" element={<HistoryPage />} />

          {token ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/summary/:patientId" element={<MedicalSummary />} />
              <Route path="/wallet-preview" element={<WalletCardPreview />} />
              <Route path="/about" element={<About />} />
              <Route path="/referral" element={<ReferralPage />} />{" "}
              <Route path="*" element={<Home />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Landing />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/login" element={<Login />} />
              <Route path="/otp-verify" element={<VerifyPage />} />
              <Route path="/sign-up" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/summary/:patientId" element={<MedicalSummary />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/wallet-preview" element={<WalletCardPreview />} />
              <Route path="/about" element={<About />} />
              <Route path="/medical-license" element={<MedicalLicenseForm />} />
              <Route
                path="/reset-password/:email/:token"
                element={<ResetPassword />}
              />
              <Route path="*" element={<Landing />} />
            </>
          )}
        </Routes>

        <ScrollToTop />
      </Router>
    </>
  );
};

export default Routing;
